import { FormSection } from 'components/form';
import {
    Typography,
    Box,
    ListItem,
    List,
    ListItemText,
    ListItemIcon,
    Link,
} from '@mui/material';
import { Help } from '@mui/icons-material';
import styles from './Install.module.scss';
import { useFormState } from 'hooks/useFormState';
import { useEffect } from 'react';

export function CreateDeviceModalInstallSection() {
    const formSectionTitle = 'Install';

    // Manage the submit button state
    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();

    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(false);
        }
    }, [setIsFormSubmitDisabled, currentFormSectionIndex, formSections]);

    return (
        <FormSection title={formSectionTitle}>
            <Box className={styles.installationDirections}>
                <Typography variant="h6" className={styles.header}>
                    Installation Steps:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText>
                            1. Attach the sensor to the gauge.
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>
                            2. Use the magnet to trigger a reading.
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>3. Go to next page.</ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <Help color="info" />
                        </ListItemIcon>
                        <ListItemText>
                            For installation instructions click{' '}
                            <Link
                                href="https://support.tankutility.com/hc/en-us/articles/360033213214-Monitor-Installation-Checklist-"
                                target="__blank"
                            >
                                here
                            </Link>
                            .
                        </ListItemText>
                    </ListItem>
                </List>
            </Box>
        </FormSection>
    );
}
